const LaptopSoundType = {
    OPEN: "device_open",
    CLOSE: "device_close",

    NOTIFICATION: "laptop_notification",
    NEWFILE: "new_file_notification",

    CLICK: "click"
};

export default LaptopSoundType;